import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csuserfunc(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# User-defined function tutorial For Beginners</title>
 <meta name="description" content="C# userDefine function tutorial for beginners.userDefine function in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# userDefine function,c# userDefined function for,c sharp userDefined function,c# user Defined function for loop,end for loop c#,c# exit for loop,exit while loop c#" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-user-define-function" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">User-defined function in C#</h1>
    <div className="first">
        <a href="/csharp-method"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-passing-argument"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
 
    <p className="mt-4 para">The Program can define its own function and a function consist of the following.
    </p>
    <h2 className="mt-4 mh2">There are 5 types of user define function in c#:
</h2>
<h3 className="mt-4 mh3">1,Function prototype(declaration)<br/>
2,Function definition<br/>
3,Calling function (accessing)<br/>
4,Function argument(parameter)<br/>
5,Return value by the function<br/>
</h3>



<h2 className='headings'>Q-Write a Program user Define Function in C# Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">class </span>
            <span className="qwerty-3">a</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-5">void </span>
            <span className="qwerty-1">hello </span>
            <span className="qwerty">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">hello </span>
            <span className="qwerty-4">function</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-7">this is a</span>
            <span className="qwerty-4"> function</span>
            <span className="qwerty-3"> programme</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">hello </span>
            <span className="qwerty">()</span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-2">//</span>
            <span className="qwerty-7"> calling function</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-6">hello is a </span>
              <span className="qwerty-4">function</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
            {"\n"} 
            <span className="qwerty-7">this is a </span>
              <span className="qwerty-4">function </span>
              <span className="qwerty-3">program</span>
              {"\n"}
              <span className="qwerty-1">hello </span>
              <span className="qwerty-4">function </span>
              {"\n"}
              <span className="qwerty-6">hello is a </span>
              <span className="qwerty-4">function </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className='headings'>Q-what will be the output of the following function program when a person goes from the USA and stay in the UK and create a plane to travel India in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">class </span>
            <span className="qwerty-3">a</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-5">void </span>
            <span className="qwerty-1">USA </span>
            <span className="qwerty">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">USA</span>
            <span className="qwerty-4"> journey</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty">static </span>
            <span className="qwerty-5">void </span>
            <span className="qwerty-1">Uk </span>
            <span className="qwerty">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">USA </span>
            <span className="qwerty-5">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">UK</span>
            <span className="qwerty-4"> journey</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">public </span>
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-4"> travel</span>
            <span className="qwerty-3"> start</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">UK </span>
            <span className="qwerty-5">()</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-1"> (</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-6">India </span>
            <span className="qwerty-4">journey</span>
            <span className="qwerty-5">"</span>
            <span className="qwerty-1">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-7">travel</span>
              {"\n"}
              <span className="qwerty-4">USA </span>
              <span className="qwerty-3">journey</span>
              {"\n"}
              <span className="qwerty-5">UK </span>
              <span className="qwerty-4">journey </span>
              {"\n"}
              <span className="qwerty-6">India </span>
              <span className="qwerty-4">journey </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>

  <div className="back">
        <a href="/csharp-method">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-passing-argument">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csuserfunc;